angular.module('shared').filter('responsiveTruncate', function() {
  return function(text, customLimit) {
    var getCharLimit, limit;
    if (!angular.isString(text)) {
      return text;
    }
    getCharLimit = function() {
      var width;
      if (customLimit != null) {
        return customLimit;
      }
      width = window.innerWidth;
      switch (false) {
        case !(width <= 768):
          return 20;
        case !(width <= 1366):
          return 30;
        case !(width <= 1700):
          return 45;
        default:
          return 75;
      }
    };
    limit = getCharLimit();
    if (text.length > limit) {
      return text.slice(0, limit) + '…';
    } else {
      return text;
    }
  };
});
